import { useEffect, useState, useCallback } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useLazyQuery, gql } from "@apollo/client";
import NestedTable from "./NestedTable";
import { useOutletContext } from 'react-router-dom';

const DHF_COLUMNS = [
	{
		id: "tableOfContent",
		label: "DHF Table of Content",
		align: "left",
	},
	{
		id: "dueDate",
		label: "Due Date",
		width: 150,
		align: "center",
	},
	{
		id: "percentageComplete",
		label: "% Complete",
		width: 150,
		align: "center",
	},
];

const DHFView = () => {
	const { navigateToWizard, ideaId } = useOutletContext();

	const [documentsData, setDocumentsData] = useState([]);

	const GET_DOCUMENTS_GQL = gql`
		query GetDocumentsData($ideaId: ID!) {
			idea(id: $ideaId) {
				dhfDocument {
					sections {
						title
						sections {
							title
							templates {
								title
								id
								docusignId
							}
						}
					}
				}
			}
		}
	`;

	const [getDocumentsData, { loading }] = useLazyQuery(GET_DOCUMENTS_GQL, {
		fetchPolicy: "no-cache",
	});

	const handleGetDocumentsData = useCallback(() => {
		getDocumentsData({
			variables: {
				ideaId,
			},
		})
			.then((res) => {
				setDocumentsData(res?.data?.idea?.dhfDocument?.sections);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [getDocumentsData, ideaId]);

	useEffect(() => {
		if (ideaId) { 
      handleGetDocumentsData();
    }
	}, [ideaId, handleGetDocumentsData]);

	console.log(documentsData);

	return (
		<Box
			sx={{
				display: "flex",
				padding: "0rem 4rem",
			}}
		>
			{loading ? (
				<Box
					sx={{
						display: "flex",
						height: "400px",
						width: "100%",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<CircularProgress />
				</Box>
			) : (
				<NestedTable
					view={"DHF"}
					columns={DHF_COLUMNS}
					records={documentsData}
					navigateToWizard={navigateToWizard}
				/>
			)}
		</Box>
	);
};

export default DHFView;
